import { DiscountConditionPopover } from '@/screens/catalog-discount/ui/discount-condition-popover/discount-condition-popover'
import QuestionIcon from '@/screens/CatalogSlug/page/assets/question.svg'

import type { DiscountProductConditionSpecs } from '@/entities/catalog-discount/schema/discount-product-detail.schema'

import { Popover } from '@/shared/ui'
import { Text } from '@/shared/ui'
import Flex from '@/shared/ui/Flex'
import { Icon } from '@/shared/ui/icon'

import specItemCl from '../../ui/product-main/product-panel/components/product-specs-panel/components/ProductSpecs/components/ProductSpecItem/product-spec-item.module.scss'
import { ProductSpecs } from '../../ui/product-main/product-panel/components/product-specs-panel/components/ProductSpecs/ProductSpecs'
import cl from '../../ui/product-main/product-panel/components/product-specs-panel/product-specs-panel.module.scss'

type DiscountProductConditionSpecsProps = {
	specs: DiscountProductConditionSpecs
}

export const DiscountProductConditionSpecsPanel = ({
	specs
}: DiscountProductConditionSpecsProps): JSX.Element | null => {
	const items = [
		specs.batterySize ? { name: `Объем аккумулятора`, value: `${specs.batterySize}%` } : null,
		specs.bundle ? { name: `Комплектация`, value: specs.bundle } : null
	].filter((item): item is { name: string; value: string } => item != null)

	if (!specs.condition && !items.length) return null

	return (
		<div className={cl.productSpecsPanel}>
			{specs.condition && (
				<div className={specItemCl.specItem}>
					<Flex alignEnd nowrap>
						<Text as="dt">
							Состояние
							<Popover
								as="span"
								style={{ marginLeft: 4 }}
								content={<DiscountConditionPopover />}
								placement="bottomRight">
								<Icon icon={QuestionIcon} width={16} height={16} />
							</Popover>
						</Text>
						<hr className={specItemCl[`specItem--underLine`]} />
						<Text as="dd">{specs.condition}</Text>
					</Flex>
				</div>
			)}
			{!!items.length && <ProductSpecs items={items} />}
		</div>
	)
}
